module.exports = __webpack_public_path__ + "static/media/PB_G_06.c267e1e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_06.png
// module id = 219
// module chunks = 0